import { hasCapability, type User } from "../base";

export const jobDetails = {
  read: (user: User) => hasCapability(user, "jobDetails.read"),
};
